import React from 'react';
import type { SummaryReport } from '../TransaccionesPageNew';

interface Props {
    summary: SummaryReport | null;
    isLoading: boolean;
}

export const TransaccionStats: React.FC<Props> = ({ summary, isLoading }) => {
    const formatMoney = (val: number) => `Bs. ${val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 px-4 sm:px-7 py-4 border-b border-gray-200 bg-gray-50 shrink-0">
            {/* Ingresos */}
            <div className="flex items-center justify-between p-3 px-4 border shadow-sm bg-white border-gray-200 rounded-xl">
                <div>
                    <div className="text-lg font-bold font-mono text-emerald-500">
                        {isLoading ? '...' : summary ? formatMoney(summary.totalEarning) : 'Bs. 0.00'}
                    </div>
                    <div className="mt-0.5 text-[10px] text-gray-500">Ingresos del mes</div>
                </div>
                <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-emerald-50 shrink-0">
                    <svg width="18" height="18" fill="none" stroke="#10b981" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                </div>
            </div>
            
            {/* Transacciones */}
            <div className="flex items-center justify-between p-3 px-4 border shadow-sm bg-white border-gray-200 rounded-xl">
                <div>
                    <div className="text-lg font-bold font-mono text-[#4f6df5]">
                        {isLoading ? '...' : summary?.transactionsCount || 0}
                    </div>
                    <div className="mt-0.5 text-[10px] text-gray-500">Transacciones</div>
                </div>
                <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-indigo-50 shrink-0">
                    <svg width="18" height="18" fill="none" stroke="#4f6df5" strokeWidth="2" viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                </div>
            </div>

            {/* Reembolsos */}
            <div className="flex items-center justify-between p-3 px-4 border shadow-sm bg-white border-gray-200 rounded-xl">
                <div>
                    <div className="text-lg font-bold font-mono text-red-500">
                        {isLoading ? '...' : summary ? formatMoney(summary.totalRefund) : 'Bs. 0.00'}
                    </div>
                    <div className="mt-0.5 text-[10px] text-gray-500">Reembolsos</div>
                </div>
                <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-red-50 shrink-0">
                    <svg width="18" height="18" fill="none" stroke="#ef4444" strokeWidth="2" viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.89"/></svg>
                </div>
            </div>

            {/* Comisiones */}
            <div className="flex items-center justify-between p-3 px-4 border shadow-sm bg-white border-gray-200 rounded-xl">
                <div>
                    <div className="text-lg font-bold font-mono text-amber-500">
                        {isLoading ? '...' : summary ? formatMoney(summary.totalJomCommission) : 'Bs. 0.00'}
                    </div>
                    <div className="mt-0.5 text-[10px] text-gray-500">Comisiones JOM</div>
                </div>
                <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-amber-50 shrink-0">
                    <svg width="18" height="18" fill="none" stroke="#f59e0b" strokeWidth="2" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                </div>
            </div>
        </div>
    );
};

export default TransaccionStats;